export const capitalizeFirstLetters = (
  text: string | number | undefined
): string => {
  if (typeof text === "number") throw new Error("Only strings allowed");
  if (!text || typeof text !== "string" || text.length === 0) return "";

  return text.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const capitalizeFirstLetter = (
  text: string | number | undefined
): string => {
  if (typeof text === "number") throw new Error("Only strings allowed");
  if (!text || typeof text !== "string" || text.length === 0) return "";

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const makePossessive = (name: string | undefined): string => {
  if (!name || typeof name !== "string" || name.length === 0)
    return name + "'s";
  return name + (name.endsWith("s") ? "'" : "'s");
};
